import Breadcrumb from 'presentations/routes/breadcrumb';
interface Props {
  title: string;
  link?: string;
}
export const setBreadcrumbs = (routes: Props[]): Breadcrumb[] => {
  return routes.map((route) => new Breadcrumb(route));
};
